import React from 'react';
import { StockLocation } from '../types/stock_location/stockLocation';

export interface StockLocationContextProps {
  stockLocations: Map<string, StockLocation>;
  setStockLocations: (productMasterData: Map<string, StockLocation>) => void;
  stockLocationsLoading: boolean;
}

const defaultContext: StockLocationContextProps = {
  stockLocations: new Map(),
  setStockLocations: () => {},
  stockLocationsLoading: false,
};

export const StockLocationContext = React.createContext<StockLocationContextProps>(defaultContext);
